<template>
  <v-container>
    <v-card>
      <template>
        <v-data-table
          :headers="headers"
          :items="list"
          :items-per-page.sync="limit"
          :options.sync="options"
          :server-items-length="count"
          :itemsPerPage="60"
          class="elevation-1"
        >
          <template v-slot:item.actions="{ item }">
              <v-btn
                small
                @click="printItem(item)"
              >
                <v-icon small>mdi-printer</v-icon>
                Print
              </v-btn>
              |
              <v-btn
                small
                @click="editItem(item)"
              >
                <v-icon small>mdi-pencil</v-icon>
                Edit
              </v-btn>
              |
              <v-btn
                small
                color="red darken-1"
                dark
                @click="deleteItem(item)"
              >
                <v-icon small>mdi-trash-can-outline</v-icon>
                Delete
              </v-btn>
          </template>
          <template v-slot:item.active="{ item }">
            <v-switch
              v-model="item.active"
              inset
              @change="activeItem(item)"
            ></v-switch>
          </template>
        </v-data-table>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
import moment from 'moment'

export default {
  name: 'AppDataTable',
  props: ['list_name', 'header_list', 'attribute_list', 'url', 'type', 'search_param'],
  data: () => ({
    headers: [],
    list: [],
    count: 0,
    loading: true,
    page: 1,
    limit: 15,
    options: {}
  }),
  watch: {
    options: {
      async handler () {
        this.loading = true
        await this.getList()
      }
    },
    search_param: {
      async handler () {
        this.loading = true
        await this.getList()
      }
    }
  },
  async mounted () {
    this.headers = this.header_list
    this.options.sortBy[0] = 'id'
    this.options.sortDesc[0] = 'DESC'
  },
  methods: {
    async getList () {
      this.page = this.options.page
      this.limit = this.options.itemsPerPage
      let url = `?limit=${this.limit}&page=${this.page}`
      if (this.search_param)
        url += `${this.search_param}`
      if (this.options.sortBy[0]) {
        url = url + `&filter[request_type]=${this.type}&sortby=${this.options.sortBy[0]}&ordering=${this.options.sortDesc[0] ? 'DESC' : 'ASC'}`
      }
      const result = await this.$http.get(`/back-office${this.url}${url}`, authHeader())
      const count = await this.$http.get(`/back-office${this.url}/count${url}`, authHeader())
      this.count = count.data
      this.list = result.data.map(item => {
        let data = {}
        for (let attribute of this.attribute_list) {
          if (attribute.includes('date') || attribute == 'createdAt' || attribute == 'updatedAt')
            data[attribute] = moment(String(item[attribute])).format('DD MMMM, YYYY hh:mm:ss a')
          else
            data[attribute] = item[attribute]
        }
        return data
      })
      this.loading = false
    },
    editItem (item) {
      this.$router.push({ name: `${this.list_name}-edit`, params: { id: item.id }});
    },
    viewItem (item) {
      this.$router.push({ name: `${this.list_name}-view`, params: { id: item.id }});
    },
    async deleteItem (item) {
      let confirmation = confirm('Are you sure you want to delete?')
      if (confirmation) {
        await this.$http.delete(`/back-office${this.url}/${item.id}`, authHeader())
        await this.getList()
      }
    },
    async activeItem (item) {
      try {
        await this.$http.put(`/back-office${this.url}/${item.id}`, { active: item.active }, authHeader())
      } catch (error) {
        console.log(error)
      }
    },
    async printItem (item) {
      try {
        const { data } = await this.$http.get(`/back-office${this.url}/${item.id}`, authHeader())
        if (!data.status_name) {
          await this.updateRequestStatus(data.id)
          await this.getList()
        }
        data.type_of_worker = data.type_of_worker ? data.type_of_worker.split(',') : null
        data.work_day = data.work_day ? data.work_day.split(',') : null
        data.helper_nationality = data.helper_nationality ? data.helper_nationality.split(',') : null
        data.expect_language = data.expect_language ? data.expect_language.split(',') : null
        data.type_of_pet = data.type_of_pet ? data.type_of_pet.split(',') : null
        data.car_type = data.car_type ? data.car_type.split(',') : null
        data.car_gear_type = data.car_gear_type ? data.car_gear_type.split(',') : null
        data.prefer_age_range = data.prefer_age_range ? data.prefer_age_range.split(',') : null
        data.expect_salary = data.expect_salary ? data.expect_salary.split(',') : null
        this.$emit('printRequest', data)
      } catch (error) {
        console.log(error)
      }
    },
    async updateRequestStatus (request_id) {
      try {
        const status_id = 1 //update status to be waiting for selecting
        await this.$http.put(`/back-office/request-helpers/${request_id}/status/${status_id}`, null, authHeader())
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
  }
}
</script>

<style>
.maid-list .v-data-table__wrapper , .driver-list .v-data-table__wrapper {
  margin-right: 0;
}

.v-data-table .v-btn {
  margin: 8px 0;
}
.v-application--is-ltr .v-data-footer__select {
  display: none;
}
</style>
